export const meetingModuleSchema = {
	schema: {
		title: 'meeting module schema',
		description: 'Meeting Module Schema',
		version: 0,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'number',
			},
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			name: {
				type: 'string',
			},
		},
		required: ['id', 'sfid', 'name'],
	},
};
